<h1>Historique</h1>

@if (!loading) {
<ng-container>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2 w-full">

        <!-- Date -->
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let h">{{ h.dateHistorique | date: 'short' }}</td>
        </ng-container>

        <!-- Acteur -->
        <ng-container matColumnDef="auteurNom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Acteur</th>
            <td mat-cell *matCellDef="let h">{{ h.auteurNom }}</td>
        </ng-container>

        <!-- Nature -->
        <ng-container matColumnDef="nature">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nature</th>
            <td mat-cell *matCellDef="let h">
                <mat-icon [ngClass]="{
          'icon-create': h.nature === 'create',
          'icon-update': h.nature === 'update',
          'icon-delete': h.nature === 'delete',
          'icon-notice': h.nature === 'notice',
          'icon-default': !['create', 'update', 'delete', 'notice'].includes(h.nature)
        }" matTooltip="{{ h.nature }}">
                    {{ getNatureIcon(h.nature) }}
                </mat-icon>
            </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let h">{{ h.description }}</td>
        </ng-container>

        <!-- Header & Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>

    @if (dataSource.data.length === 0) {
    <div class="empty-state">Aucun historique à afficher.</div>
    }
</ng-container>
} @else {
<div class="spinner-container">
    <mat-spinner></mat-spinner>
</div>
}